import React from "react"

import { OneVerifyEraUploadFileFormat } from "@common-shared/config/oneVerify/oneVerifyIntegrations.config"
import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { INTEGRATIONS_CONFIG } from "../../../config/integrations.config"

export const EraUploadFormatTabsComponent: React.FunctionComponent<
    IEraUploadFormatTabsComponentProps
> = props => {
    return (
        <div
            className={`
                flex items-end gap-[24px] border-b border-solid border-brand-warmLight
                ${props.className ?? ""}
            `}
            role="tablist"
            aria-label="ERA upload format"
        >
            {INTEGRATIONS_CONFIG.eraUpload.uploadFormatTabs.map(tab => {
                const isActive = tab.key === props.activeFormat

                return (
                    <div
                        key={tab.key}
                        role="tab"
                        aria-selected={isActive}
                        tabIndex={0}
                        className="relative pb-[10px] cursor-pointer"
                        onClick={() => {
                            props.onFormatChange(tab.key)
                        }}
                        onKeyDown={event => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault()
                                props.onFormatChange(tab.key)
                            }
                        }}
                    >
                        <PrimaryText
                            typography={isActive ? "textSemibold" : "text"}
                            color={
                                isActive
                                    ? undefined
                                    : NIRVANA_COLORS.brand.grey7
                            }
                        >
                            {tab.label}
                        </PrimaryText>

                        <span
                            aria-hidden
                            className={`
                                absolute left-0 bottom-0 w-full rounded-t-[2px]
                                bg-brand-primary
                                ${isActive ? "h-[3px]" : "h-[1px] opacity-40"}
                            `}
                        />
                    </div>
                )
            })}
        </div>
    )
}

interface IEraUploadFormatTabsComponentProps {
    className?: string
    activeFormat: OneVerifyEraUploadFileFormat
    onFormatChange: (format: OneVerifyEraUploadFileFormat) => void
}
